export const variantPrefix = 'hackjanelas2023'

export const origins = {
  individualOriginIdentifier: `${variantPrefix}individual`,
  mentorOriginIdentifier: `${variantPrefix}mentor`,
  judgeOriginIdentifier: `${variantPrefix}judge`,
  reportAOriginIdentifier: `${variantPrefix}reporta`,
  reportBOriginIdentifier: `${variantPrefix}reportb`,
  reportCOriginIdentifier: `${variantPrefix}reportc`,
}

export const originsIdentifiers = Object.values(origins)
